"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergeStylesRootStylesheets = void 0;
var React = require("react");
var MergeStylesRootContext_1 = require("../contexts/MergeStylesRootContext");
/**
 * Get the map of stylesheets available in the context.
 */
var useMergeStylesRootStylesheets = function () {
    return React.useContext(MergeStylesRootContext_1.MergeStylesRootContext).stylesheets;
};
exports.useMergeStylesRootStylesheets = useMergeStylesRootStylesheets;
//# sourceMappingURL=useMergeStylesRootStylesheets.js.map